import { useEffect, useState } from "react";
import { IUser } from "@/models/User";
import { UsersApi } from "@/api";

const useUsers = () => {
  const [users, setUsers] = useState<IUser[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const users = await UsersApi.getUsers();
        setUsers(users);
      } catch (e) {}
    })();
  }, []);

  const addNewUser = (user: IUser) => {
    setUsers((prevUsers) => [...prevUsers, user]);
  };

  const deleteUser = (userId: number) => {
    setUsers((prevUsers) =>
      prevUsers.filter((prevUser) => prevUser.userId !== userId)
    );
  };

  const editUser = (user: IUser) => {
    setUsers((prevUsers) =>
      prevUsers.map((prevUser) =>
        prevUser.userId === user.userId ? user : prevUser
      )
    );
  };

  return {
    users,
    addNewUser,
    editUser,
    deleteUser,
  };
};

export default useUsers